require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-mittagessen-mittagessen-0-3-2020-21.json") })
        }
      }, "path---kriterien-mittagessen-mittagessen-0-3-2020-21");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-mittagessen-mittagessen-0-3-2020-21!./.cache/json/kriterien-mittagessen-mittagessen-0-3-2020-21.json
// module id = 1060
// module chunks = 231608221292675